import {
    createTextHeader,
    TextHeader,
} from '@vfde-brix/ws10/text-header';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-sails/constants';
import { startAppListening } from '../app/listener';
import { selectSubscriptionId } from '../features/app/slice';

/**
 * Mount Text Header
 */
export const mountTextHeader = (containerId: string): TextHeader | null => {
    const container = document.getElementById(containerId);

    /* istanbul ignore if */
    if (!container) {
        return null;
    }

    const textHeader = createTextHeader(container, NO_PATTERN_BUSINESS_LOGIC);

    listenForUpdates(textHeader);

    return textHeader;
};

const listenForUpdates = (textHeader: TextHeader) => {
    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectSubscriptionId(currentState) !== selectSubscriptionId(previousState)
        ,
        effect: (_action, listenerApi) => {
            updateTextHeader(textHeader, selectSubscriptionId(listenerApi.getState()));
        },
    });
};

/**
 * Update Text Header
 */
const updateTextHeader = (textHeader: TextHeader, subscriptionId: string | undefined): void => {
    const headingContent = getHeadingContent(subscriptionId);

    textHeader && headingContent && textHeader.update({
        stdHeadline: headingContent.headline,
        stdSubline: headingContent.subline,
    });
};

/**
 * Get heading content
 */
const getHeadingContent = (subscriptionId: string | undefined) => {
    const headings = window[ADDITIONAL_PAGE_OPTIONS].headings || {};
    const headingContent = subscriptionId && headings[subscriptionId] ? headings[subscriptionId] : headings.default;

    return headingContent;
};
